import React from 'react';
import './Offerings.css';
import OfferingCard from './OfferingCard';

const offeringsData = [
  { title: 'Upload unlimited recorded classes', description: 'Upload and stream unlimited number of pre-recorded class videos...', icon: '📹' },
  { title: 'Create & Edit Video', description: 'Create videos with content and edit them within the platform...', icon: '✂️' },
  { title: 'Create & Schedule Live Video Classes', description: 'Host or schedule live classes in real-time...', icon: '🎥' },
  { title: 'Schedule In-Person Appointments', description: 'Book face-to-face appointments for tutoring...', icon: '📅' },
  { title: 'Emails to Customers & Employees', description: 'Send professional emails, updates...', icon: '📧' },
  { title: 'Create Roles For Employees', description: 'Add employees, assign roles...', icon: '👥' },
  { title: 'Create Quizzes & Assignments', description: 'Design and assign quizzes...', icon: '📝' },
  { title: 'Business Reports and Analytics', description: 'Get insights into business performance...', icon: '📊' },
  { title: 'Business Recommendations', description: 'Provide market insights...', icon: '💡' },
];

const Offerings = () => (
  <section className="offerings">
    <h2>Our Offerings</h2>
    <p>Empowering you with tools to create, schedule, and manage classes effortlessly.</p>
    <div className="offerings-grid">
      {offeringsData.map((offering, index) => (
        <OfferingCard key={index} {...offering} />
      ))}
    </div>
  </section>
);

export default Offerings;
